import { Reveal, MaskedLine } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit our contact form, we collect your name, email address, and any optional details you choose to share (phone, organization, child's age, and your message). We use this information solely to respond to your inquiry and provide the services you request.",
  },
  {
    title: "How we use it",
    body: "Your information is used to communicate with you about your inquiry, schedule consultations, and deliver coaching or consultation services. We do not sell, rent, or share your personal information with third parties for marketing purposes.",
  },
  {
    title: "Confidentiality",
    body: "As a family coaching and caregiver support practice, we treat all client and family information with professional confidentiality. Details shared in coaching sessions are never used in marketing, training, or publications without explicit written consent.",
  },
  {
    title: "Data retention",
    body: "Inquiry records are retained only as long as needed to serve you and meet professional obligations. You may request deletion of your inquiry data at any time by emailing us.",
  },
  {
    title: "Cookies & analytics",
    body: "This site uses minimal, privacy-respecting analytics to understand how visitors use the site. No advertising trackers are used. Your theme preference is stored locally in your browser and never leaves your device.",
  },
];

export default function Privacy() {
  return (
    <section className="container-site pb-24 pt-16 sm:pt-24" data-testid="privacy-page">
      <p className="overline-label">Privacy Policy</p>
      <h1 className="mt-5 max-w-3xl font-heading text-4xl font-semibold leading-[1.08] tracking-tight text-foreground sm:text-5xl">
        <MaskedLine delay={0.1}>Your privacy,</MaskedLine>
        <MaskedLine delay={0.25}>
          <span className="text-terracotta-500">taken seriously.</span>
        </MaskedLine>
      </h1>
      <Reveal delay={0.4}>
        <p className="mt-6 text-sm text-muted-foreground">Last updated: July 2026</p>
        <div className="mt-12 max-w-3xl space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="font-heading text-xl font-semibold text-foreground">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">{s.body}</p>
            </div>
          ))}
          <div className="rounded-3xl border border-border bg-card p-8">
            <h2 className="font-heading text-xl font-semibold text-foreground">Questions?</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              Email us at{" "}
              <a href={`mailto:${CONTACT.email}`} data-testid="privacy-email-link" className="font-medium text-forest transition-colors duration-300 hover:text-terracotta-500 dark:text-sage">
                {CONTACT.email}
              </a>{" "}
              and we will respond within one to two business days.
            </p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
